"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconGreenSteel = function IconGreenSteel(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m35.317 2.68-1.96-.286-.706-.092-.888-.103a65 65 0 0 0-3.697-.304l-.593-.026c-3.838-.144-6.53.204-8.09 1.104a8.24 8.24 0 0 0-4.172 6.68l-.011.308 1.998.07.01-.283.022-.26a6.24 6.24 0 0 1 3.145-4.778c1.201-.693 3.726-.996 7.434-.825l1.052.061c.9.062 1.804.144 2.683.24l.302.035.7.082-.155.362a71 71 0 0 1-1.854 3.92l-.183.349c-1.633 3.093-3.092 5.01-4.241 5.673-2.972 1.716-6.38.95-7.937-1.746l-.5-.866-5.196 3 1 1.733 3.521-2.034.124.157c2.333 2.867 6.464 3.522 9.988 1.488 1.616-.933 3.328-3.22 5.199-6.833l.226-.44c.89-1.763 1.839-3.91 2.06-4.527l.01-.033zm-7.54 4.811-3.846 2.221 2.713.728-.26.966-3.674-.985.001-.005-.253.147-.002.005-.003-.002-2.47 1.425-.5-.866L21.6 9.904l.902-3.366.966.26-.643 2.399 4.454-2.572zM28 28h-8v6h8zm-8-2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zM6 20h36v8h-7v6h7v8H6v-8h7v-6H6v-8m2 6h5a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H8v4h32v-4h-5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5v-4H8v4m27-2.486h-5v1h5zm1 0h2v1h-2zM15.044 37.613h-5v1h5zm1 0h2v1h-2z",
    clipRule: "evenodd"
  })));
};

export { IconGreenSteel, IconGreenSteel as default };
